import React from "react"
import {Editable, EditableBooleanField} from "../HorizontalField/EditableHorizontalField"

export interface EditableIsRegulatedProps {
	isRegulated?: boolean
	setIsRegulated: (value: boolean) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	isUpdating: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: boolean) => void
	className?: string
}

export function EditableIsRegulatedField(props: EditableIsRegulatedProps) {
	if (props.isRegulated === undefined) {
		return null
	}

	return (
		<Editable
			label="Is Regulated"
			isEditing={props.isEditing}
			isDisabled={props.isDisabled}
			isAllowed={props.isAllowed}
			onStartEdit={props.onStartEdit}
			onCancel={props.onCancel}
			setValue={props.setIsRegulated}
			value={props.isRegulated}
			initial={props.isRegulated}
			update={props.update}
			className={props.className}
		>
			{EditableBooleanField}
		</Editable>
	)
}
